/**
 * Template base para emails HTML do GetPoints.
 * Layout profissional responsivo com logo, header, body, prazo de expiração e footer.
 */

export interface EmailBaseParams {
  titulo: string;
  saudacao: string;
  conteudo: string;
  prazoExpiracao?: string;
  mostrarLogo?: boolean;
}

const LOGO_URL =
  'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/6356cf72c36f3ef424056fffdf6d6f31.png';

export function montarBase(params: EmailBaseParams): string {
  const prazo = params.prazoExpiracao
    ? `<table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 24px;">
          <tr>
            <td style="background-color: #FEF3C7; border: 1px solid #FCD34D; border-radius: 8px; padding: 16px 20px;">
              <table cellpadding="0" cellspacing="0">
                <tr>
                  <td style="vertical-align: top; padding-right: 12px;">
                    <span style="font-size: 20px; color: #D97706;">&#9888;</span>
                  </td>
                  <td style="font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;">
                    <p style="margin: 0 0 4px 0; font-size: 14px; font-weight: 700; color: #92400E;">Prazo de Expiração</p>
                    <p style="margin: 0; font-size: 13px; color: #A16207; line-height: 1.5;">${params.prazoExpiracao}</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>`
    : '';

  const headerContent = params.mostrarLogo !== false
    ? `<tr>
          <td style="background-color: #FFFFFF; padding: 36px 40px 12px 40px; text-align: center;">
            <img src="${LOGO_URL}" alt="GetPoints" style="height: 48px; width: auto; display: block; margin: 0 auto 20px auto;" />
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td>
                  <div style="height: 3px; background: linear-gradient(90deg, #F97316, #FB923C, #F97316); border-radius: 2px;"></div>
                </td>
              </tr>
            </table>
            <h1 style="margin: 18px 0 0 0; font-size: 20px; font-weight: 700; color: #1E293B; letter-spacing: -0.3px;">${params.titulo}</h1>
          </td>
        </tr>`
    : `<tr>
          <td style="background-color: #FFFFFF; padding: 32px 40px 12px 40px; text-align: center;">
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td>
                  <div style="height: 3px; background: linear-gradient(90deg, #F97316, #FB923C, #F97316); border-radius: 2px;"></div>
                </td>
              </tr>
            </table>
            <h1 style="margin: 18px 0 0 0; font-size: 20px; font-weight: 700; color: #1E293B; letter-spacing: -0.3px;">${params.titulo}</h1>
          </td>
        </tr>`;

  return `<!DOCTYPE html>
<html lang="pt-BR" xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <title>${params.titulo}</title>
</head>
<body style="margin: 0; padding: 0; background-color: #F1F5F9; font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;">
  <!-- Preheader (invisible text for email clients) -->
  <div style="display: none; max-height: 0; overflow: hidden; font-size: 1px; line-height: 0; color: #F1F5F9;">
    ${params.titulo} - GetPoints
  </div>

  <!-- Wrapper -->
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #F1F5F9; padding: 48px 0;">
    <tr>
      <td align="center">
        <!-- Container principal (600px) -->
        <table width="600" cellpadding="0" cellspacing="0" style="max-width: 600px; border-radius: 10px; overflow: hidden;">

          <!-- Header -->
          ${headerContent}

          <!-- Body -->
          <tr>
            <td style="background-color: #FFFFFF; padding: 32px 40px 40px 40px;">
              <!-- Saudação -->
              <p style="margin: 0 0 20px 0; font-size: 16px; color: #334155; line-height: 1.6;">
                ${params.saudacao}
              </p>

              <!-- Conteúdo principal -->
              ${params.conteudo}

              <!-- Prazo de expiração -->
              ${prazo}

              <!-- Separador -->
              <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 32px;">
                <tr>
                  <td style="border-top: 1px solid #E2E8F0; padding-top: 24px;">
                    <p style="margin: 0; font-size: 13px; color: #94A3B8; line-height: 1.6;">
                      Caso tenha dúvidas, entre em contato com nossa equipe de suporte pelo e-mail
                      <a href="mailto:contato@getpoints.com.br" style="color: #F97316; text-decoration: none; font-weight: 600;">contato@getpoints.com.br</a>
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Divisor sutil entre body e footer -->
          <tr>
            <td style="background-color: #FFFFFF;">
              <div style="height: 1px; background-color: #E2E8F0; margin: 0 40px;"></div>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background-color: #F8FAFC; padding: 28px 40px; text-align: center;">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td align="center">
                    <img src="${LOGO_URL}" alt="GetPoints" style="height: 22px; width: auto; display: block; margin-bottom: 14px; opacity: 0.7;" />
                  </td>
                </tr>
                <tr>
                  <td style="font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;">
                    <p style="margin: 0 0 8px 0; font-size: 11px; color: #94A3B8; line-height: 1.5;">
                      &copy; 2026 GetPoints Tecnologia, C.R.I.E. Ltda. &mdash; Todos os direitos reservados.
                    </p>
                    <p style="margin: 0 0 14px 0; font-size: 11px; color: #94A3B8; line-height: 1.5;">
                      Plataforma de Gestão de Incentivos e Gamificação
                    </p>
                    <table cellpadding="0" cellspacing="0" style="margin: 0 auto;">
                      <tr>
                        <td style="padding: 0 12px;">
                          <a href="https://getpoints.com.br" style="font-size: 11px; color: #64748B; text-decoration: none;">https://www.getpoints.com.br</a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;
}